import React, { useState } from 'react';
import Dashboard from './components/Dashboard';
import QuotationList from './components/QuotationList';
import QuotationDetail from './components/QuotationDetail';
import Analytics from './components/Analytics';
import Settings from './components/Settings';
import AIAssistant from './components/AIAssistant';
import UserManagement from './components/UserManagement';
import { Quotation, dummyQuotations } from './data/dummyData';

type View = 'dashboard' | 'quotations' | 'quotation-detail' | 'analytics' | 'settings' | 'ai-assistant' | 'user-management';

function App() {
  const [currentView, setCurrentView] = useState<View>('dashboard');
  const [selectedQuotation, setSelectedQuotation] = useState<Quotation | null>(null);

  const handleQuotationSelect = (quotation: Quotation) => {
    setSelectedQuotation(quotation);
    setCurrentView('quotation-detail');
  };

  const handleBackToQuotations = () => {
    setSelectedQuotation(null);
    setCurrentView('quotations');
  };

  const handleBackToDashboard = () => {
    setCurrentView('dashboard');
  };

  const handleViewQuotations = () => {
    setCurrentView('quotations');
  };

  const handleNavigate = (view: 'dashboard' | 'quotations' | 'analytics' | 'settings' | 'ai-assistant' | 'user-management') => {
    setCurrentView(view);
  };

  return (
    <div className="App">
      {currentView === 'dashboard' && (
        <Dashboard onViewQuotations={handleViewQuotations} onNavigate={handleNavigate} />
      )}
      {currentView === 'quotations' && (
        <QuotationList
          quotations={dummyQuotations}
          onQuotationSelect={handleQuotationSelect}
          onBackToDashboard={handleBackToDashboard}
          onNavigate={handleNavigate}
        />
      )}
      {currentView === 'quotation-detail' && selectedQuotation && (
        <QuotationDetail
          quotation={selectedQuotation}
          onBack={handleBackToQuotations}
          onNavigate={handleNavigate}
        />
      )}
      {currentView === 'analytics' && (
        <Analytics
          quotations={dummyQuotations}
          onBackToDashboard={handleBackToDashboard}
          onNavigate={handleNavigate}
        />
      )}
      {currentView === 'settings' && (
        <Settings onBackToDashboard={handleBackToDashboard} onNavigate={handleNavigate} />
      )}
      {currentView === 'ai-assistant' && (
        <AIAssistant onBackToDashboard={handleBackToDashboard} onNavigate={handleNavigate} />
      )}
      {currentView === 'user-management' && (
        <UserManagement onBackToDashboard={handleBackToDashboard} onNavigate={handleNavigate} />
      )}
    </div>
  );
}

export default App;
